import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MOVE_DOWN, MOVE_UP, REMOVE } from './types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledButtonGroupWrapper = styled(UIButtonGroup).withConfig({
  displayName: "FileActions__StyledButtonGroupWrapper",
  componentId: "baugdk-0"
})(["flex-shrink:0;margin-right:6px;"]);
const getButtonTooltip = (type, disabled, uploadsInProgress) => {
  if (!disabled || uploadsInProgress) {
    return null;
  }
  if (type === 'up') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputFilesV2.upButtonDisableTooltip"
    });
  }
  if (type === 'down') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputFilesV2.downButtonDisableTooltip"
    });
  }
  return null;
};
const FileActions = ({
  fileId,
  disabled,
  index,
  totalFiles,
  uploadsInProgress,
  onFileAction
}) => {
  const disableUpButton = index === 0 || disabled;
  const disableDownButton = index === totalFiles - 1 || disabled;
  const disableRemoveButton = disabled;
  return /*#__PURE__*/_jsxs(StyledButtonGroupWrapper, {
    style: {
      flexShrink: 0
    },
    children: [/*#__PURE__*/_jsx(UIIconButton, {
      size: "small",
      use: "link",
      disabled: disableUpButton,
      onClick: () => onFileAction({
        action: MOVE_UP,
        fileId
      }),
      tooltip: getButtonTooltip('up', disableUpButton, uploadsInProgress),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "up"
      })
    }), /*#__PURE__*/_jsx(UIIconButton, {
      size: "small",
      use: "link",
      disabled: disableDownButton,
      onClick: () => onFileAction({
        action: MOVE_DOWN,
        fileId
      }),
      tooltip: getButtonTooltip('down', disableDownButton, uploadsInProgress),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "down"
      })
    }), /*#__PURE__*/_jsx(UIIconButton, {
      size: "small",
      use: "link",
      disabled: disableRemoveButton,
      onClick: () => onFileAction({
        action: REMOVE,
        fileId
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "remove",
        size: 12
      })
    })]
  });
};
export default /*#__PURE__*/memo(FileActions);